import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, MessageCircle, BarChart3 } from 'lucide-react';
const points = [{
  icon: Smartphone,
  title: 'Enfoque específico para tiendas de iPhone',
  desc: 'No está pensado para cualquier negocio. La guía trabaja sobre modelos de iPhone, ofertas, plan canje, campañas de mensajes, tráfico al perfil y conversaciones reales de compra.'
}, {
  icon: MessageCircle,
  title: 'Pensado para vender por mensaje',
  desc: 'El sistema no depende de una página web ni de un embudo complejo. Está enfocado en generar conversaciones por Instagram, mejorar la calidad de los mensajes y ayudar a que el vendedor tenga más oportunidades reales.'
}, {
  icon: BarChart3,
  title: 'Basado en decisiones prácticas',
  desc: 'No se trata solo de prender campañas. La guía ayuda a entender qué modelo anunciar, qué ángulo usar, cómo comunicar la oferta y cómo analizar si los mensajes que llegan tienen potencial de compra.'
}];
export function SocialProof() {
  return <section className="py-20 md:py-28 bg-white border-t border-zinc-200" data-id="element-296">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-297">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-298">
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 tracking-tight mb-4 text-balance" data-id="element-299">
            Por qué esta guía no es otro tutorial genérico de anuncios
          </h2>
          <p className="text-lg text-zinc-600 text-balance" data-id="element-300">
            Sistema iPhone Ads está pensado específicamente para tiendas,
            revendedores y personas que venden iPhones por Instagram y concretan
            ventas por conversación.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-301">
          {points.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-zinc-50 rounded-2xl p-7 border border-zinc-200" data-id="element-302">
                <div className="w-11 h-11 rounded-xl bg-blue-600 text-white flex items-center justify-center mb-5" data-id="element-303">
                  <Icon className="w-5 h-5" data-id="element-304" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-zinc-900 mb-3 leading-tight" data-id="element-305">
                  {point.title}
                </h3>
                <p className="text-zinc-600 leading-relaxed text-sm md:text-base" data-id="element-306">
                  {point.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center text-sm text-zinc-500 mt-10 max-w-2xl mx-auto leading-relaxed" data-id="element-307">
          Cuando tenga testimonios reales, esta sección podrá reemplazarse por
          casos, capturas y feedback de compradores. Por ahora, la prioridad es
          mostrar con claridad qué hace diferente al sistema.
        </motion.p>
      </div>
    </section>;
}